import React from "react";
import { SafeAreaView, Platform, StatusBar } from "react-native";

import {
  Typography,
  OldButton as Button,
  Spacer,
  Stack,
  Float,
} from "digiwash-components";
import Icon from "../Icon";

let pb = 0;
if (Platform.OS === "android") {
  pb = StatusBar.currentHeight;
} else if (Platform.OS === "web") {
  pb = 24;
}

const safeAreStyles = {
  flex: 1,
  paddingBottom: pb,
};

interface PropTypes {
  onSave: () => void;
  disabled?: boolean;
}

function SaveMapButton(props: PropTypes) {
  return (
    <Float px="m" fullWidth>
      <SafeAreaView style={safeAreStyles}>
        <Stack distribution="center">
          <Button
            size="l"
            type="circle-like"
            bg="green.main"
            onPress={props.onSave}
            disabled={props.disabled}
          >
            <Stack>
              <Typography color="common.white" ff="mainBold">
                ثبت آدرس
              </Typography>
              <Spacer size="m" />
              <Icon color="common.white" name="arrow-left" size={16} />
            </Stack>
          </Button>
        </Stack>
      </SafeAreaView>
    </Float>
  );
}

export default SaveMapButton;
